@if (selectedSlide) {
  <ion-content>
    <ion-grid>
      <ion-row>
        <ion-col size="12" class="upper-col">
          <div class="upper-col__content">
            <ion-buttons slot="start" (click)="goBack()">
              <ion-icon name="md-arrow-round-back"></ion-icon>
            </ion-buttons>
            <img alt="slider-image" src="{{ selectedSlide?.slider_full }}" />
          </div>
        </ion-col>
        <ion-col size="12" class="bottom-col">
          <div class="bottom-col__content">
            <h4 class="bottom-col__content__title">{{ selectedSlide?.title }}</h4>
            <h6 class="bottom-col__content__description" [innerHTML]="selectedSlide?.content"></h6>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>
} @else {
  <app-in-progress-animation></app-in-progress-animation>
}
